if (!customElements.get('deployer-cart-drawer')) {
  customElements.define(
    'deployer-cart-drawer',
    class DeployerCartDrawer extends HTMLElement {
      constructor() {
        super();
 
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
 
        this.querySelector('#DeployerCartDrawer-Checkout').addEventListener('click', (event) => {
          event.target.classList.add('deployer-button--is-loading');
        });
 
        // Connecte le panier à l'icône du panier
        this.setHeaderCartIconAccessibility();
 
        // Connecte le panier aux formulaires des pages produit
        this.setProductFormCompatibility(this);
 
        this.connectCartItemsListeners();
      }
 
      connectCartItemsListeners() {
        // Supprimer les anciens event listeners s'ils existent
        if (this.boundItemsClickHandler) {
          this.removeEventListener('click', this.boundItemsClickHandler);
        }
        if (this.boundItemsChangeHandler) {
          this.removeEventListener('change', this.boundItemsChangeHandler);
        }
        if (this.boundOverlayClickHandler) {
          this.querySelector('.deployer-cart-drawer__overlay').removeEventListener('click', this.boundOverlayClickHandler);
        }

        // Overlay click handler
        this.boundOverlayClickHandler = this.close.bind(this);
        this.querySelector('.deployer-cart-drawer__overlay').addEventListener('click', this.boundOverlayClickHandler);
 
        // Refresh cart event
        if (!this.boundRefreshHandler) {
          this.boundRefreshHandler = () => {
            this.refreshCart();
          };
          document.addEventListener('deployer-cart-drawer:refresh', this.boundRefreshHandler);
        }
 
        // Event delegation pour les clics sur les boutons de quantité et suppression
        this.boundItemsClickHandler = (event) => {
          const target = event.target;
          const button = target.closest('button');
          if (!button) return;

          // Bouton de suppression
          if (button.classList.contains('deployer-cart-drawer__item-remove-button')) {
            event.preventDefault();
            const removeDiv = button.closest('.deployer-cart-drawer__item-remove');
            if (removeDiv) {
              this.updateLineItemQuantity(removeDiv.dataset.index, 0);
            }
          }

          // Boutons de quantité
          if (button.closest('.deployer-quantity')) {
            event.preventDefault();
            const quantityDiv = button.closest('.deployer-quantity');
            const input = quantityDiv.querySelector('input');
            if (input && !button.disabled) {
              this.onQuantityButtonClick(event, input);
            }
          }
        };

        // Event delegation pour les changements d'input
        this.boundItemsChangeHandler = (event) => {
          const target = event.target;
          if (target.matches('.deployer-quantity input')) {
            this.updateLineItemQuantity(target.dataset.index, target.value);
          }
        };

        // Ajouter les event listeners avec delegation
        this.addEventListener('click', this.boundItemsClickHandler);
        this.addEventListener('change', this.boundItemsChangeHandler);
      }
 
      setHeaderCartIconAccessibility() {
        if (window.deployerAdapter && window.deployerAdapter.cartIcon) {
          window.deployerAdapter.cartIcon.addEventListener('click', (event) => {
            event.preventDefault();
            this.open();
          });
        } else {
          console.error('Icône du panier non trouvée');
        }
      }
 
      // Intercepte les ajouts au panier pour les envoyer à la méthode de rendu du panier
      setProductFormCompatibility(cartDrawer) {
        document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
          form.querySelectorAll('[name="add"]').forEach((button) => {
            button.addEventListener('click', function (event) {
              event.preventDefault(), event.stopPropagation();
 
              if (button.getAttribute('aria-disabled') === 'true') return;
 
              button.setAttribute('aria-disabled', true);
              button.classList.add('deployer-button--is-loading');
 
              const config = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
              };
              config.headers['X-Requested-With'] = 'XMLHttpRequest';
              delete config.headers['Content-Type'];
 
              const formData = new FormData(button.closest('form'));
 
              formData.append(
                'sections',
                document
                  .querySelector('deployer-cart-drawer')
                  .getSectionsToRender()
                  .map((section) => section.section)
              );
              formData.append('sections_url', window.location.pathname);
 
              config.body = formData;
 
              fetch('/cart/add', config)
                .then((response) => response.json())
                .then((response) => {
                  if (response.status) {
                    document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: response.description } }));
                    return;
                  }
                  document.querySelector('deployer-cart-drawer').renderCartContents(response);
                })
                .catch((e) => {
                  console.error(e);
                  document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: "Erreur d'ajout au panier" } }));
                })
                .finally(() => {
                  button.classList.remove('deployer-button--is-loading');
                  button.removeAttribute('aria-disabled');
                });
            });
          });
        });
      }
 
      open() {
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => {
          this.classList.add('animate', 'active');
        });
        
        if (window.deployerAdapter && window.deployerAdapter.containerToAvoidScroll && window.deployerAdapter.classToAvoidScroll) {
          window.deployerAdapter.containerToAvoidScroll.classList.add(window.deployerAdapter.classToAvoidScroll);
        }
      }
 
      close() {
        this.classList.remove('active');
        
        if (window.deployerAdapter && window.deployerAdapter.containerToAvoidScroll && window.deployerAdapter.classToAvoidScroll) {
          window.deployerAdapter.containerToAvoidScroll.classList.remove(window.deployerAdapter.classToAvoidScroll);
          if (window.deployerAdapter.containerToAvoidScroll.style.overflow === 'hidden') {
            window.deployerAdapter.containerToAvoidScroll.style.overflow = 'auto';
          }
        }
      }
 
      getSectionsToRender() {
        const sections = [
          {
            id: 'deployer-cart-drawer',
            section: 'deployer-cart-drawer',
            selector: '.deployer-cart-drawer__inner',
          },
        ];

        return sections;
      }
 
      // Méthode pour mettre à jour la bulle du panier directement
      updateCartBubble(itemCount) {
        console.log('updateCartBubble', itemCount);
        const cartIconBubble = document.querySelector('.cart-count-bubble');
        console.log('cartIconBubble', cartIconBubble);

        if (!cartIconBubble) {
          console.log('cartIconBubble not found');
          return;
        }


        if (itemCount > 0) {
          cartIconBubble.classList.remove('hidden');
        } else {
          cartIconBubble.classList.add('hidden');
        }
      }
 
      renderCartContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          if (sectionElement && parsedState.sections[section.id]) {
            const temporaryDom = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
            if (temporaryDom.querySelector(section.selector)) {
              sectionElement.innerHTML = temporaryDom.querySelector(section.selector).innerHTML;
            } else {
              sectionElement.innerHTML = temporaryDom.querySelector('.shopify-section').innerHTML;
            }
          }
        });
 
        // Mise à jour spécifique de la bulle du panier si elle n'est pas dans les sections
        if (parsedState.item_count !== undefined) {
          this.updateCartBubble(parsedState.item_count);
        }
 
        setTimeout(() => {
          this.open();
          this.connectCartItemsListeners();
          if (parsedState.item_count == 0) {
            this.classList.add('deployer-cart-drawer--empty');
          } else {
            this.classList.remove('deployer-cart-drawer--empty');
          }
        });
      }
 
      refreshCart() {
        // Met à jour le cart drawer et la bulle du panier
        fetch(window.Shopify.routes.root + '?sections=deployer-cart-drawer')
          .then((res) => res.json())
          .then((data) => {
            // Met à jour le cart drawer
            if (data['deployer-cart-drawer']) {
              this.innerHTML = new DOMParser().parseFromString(data['deployer-cart-drawer'], 'text/html').querySelector('deployer-cart-drawer').innerHTML;
            }
            
            // Met à jour la bulle du panier en récupérant le nombre d'articles
            fetch('/cart.js')
              .then((res) => res.json())
              .then((cart) => {
                this.updateCartBubble(cart.item_count);
              })
              .catch((error) => {
                console.error('Erreur lors de la récupération du panier:', error);
              });
            
            setTimeout(() => {
              this.connectCartItemsListeners();
            });
          });
      }
 
      onQuantityButtonClick(event, cart_item_input) {
        event.preventDefault();
        const previousValue = cart_item_input.value;
        const button = event.target.closest('button');
 
        button.name === 'plus' ? cart_item_input.stepUp() : cart_item_input.stepDown();
        if (previousValue !== cart_item_input.value) {
          let timeout;
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.updateLineItemQuantity(cart_item_input.dataset.index, cart_item_input.value);
          }, 300);
        }
      }
 
      updateLineItemQuantity(line, quantity) {
        this.enableLoading(line);
 
        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });
 
        fetch('/cart/change', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json` }, ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            const quantityElement = document.getElementById(`DeployerCartDrawer-Quantity-${line}`);
 
            if (parsedState.errors) {
              quantityElement.value = quantityElement.getAttribute('value');
              this.setLineItemError(line, parsedState.errors);
              return;
            }
 
            this.renderCartContents(parsedState);
          })
          .catch((e) => {
            console.error(e);
            this.setCartError('Une erreur est survenue lors de l’actualisation de votre panier. Veuillez réessayer.');
            this.disableLoading(line);
          })
          .finally(() => {
            this.disableLoading(line);
          });
      }
 
      setLineItemError(line, message) {
        if (document.querySelector('deployer-toast-notification')) {
          document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
          return;
        }
        const lineItemError = document.getElementById(`DeployerCartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.deployer-cart-drawer__item-error-text').innerHTML = message;
      }
 
      setCartError(message) {
        if (document.querySelector('deployer-toast-notification')) {
          document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message: message } }));
          return;
        }
        document.getElementById('DeployerCartDrawer-CartErrors').textContent = message;
      }
 
      enableLoading(line) {
        const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
        if (mainCartItems) {
          mainCartItems.classList.add('deployer-cart-drawer__items--disabled');
        }
        
        const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
        cartDrawerItemElements.forEach((overlay) => overlay.classList.remove('hidden'));
        
        const totalsValue = document.querySelector('.deployer-cart-drawer__totals-value');
        if (totalsValue) {
          totalsValue.classList.add('deployer-loading');
        }
        

        
        const itemPrices = document.querySelector(`#DeployerCartDrawer-Item-${line} .deployer-cart-drawer__item-prices`);
        if (itemPrices) {
          itemPrices.classList.add('deployer-loading');
        }
      }
 
      disableLoading(line) {
        const mainCartItems = document.querySelector('.deployer-cart-drawer__items');
        if (mainCartItems) {
          mainCartItems.classList.remove('deployer-cart-drawer__items--disabled');
        }
        
        const cartDrawerItemElements = this.querySelectorAll(`#DeployerCartDrawer-Item-${line} .loading__spinner`);
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        
        const totalsValue = document.querySelector('.deployer-cart-drawer__totals-value');
        if (totalsValue) {
          totalsValue.classList.remove('deployer-loading');
        }
        

        
        const itemElement = document.querySelector(`#DeployerCartDrawer-Item-${line}`);
        if (itemElement) {
          const itemPrices = itemElement.querySelector('.deployer-cart-drawer__item-prices');
          if (itemPrices) {
            itemPrices.classList.remove('deployer-loading');
          }
        }
      }
    }
  );
}
 
class DeployerCartNote extends HTMLElement {
  constructor() {
    super();
 
    let inputTimeout;
    this.addEventListener('input', (event) => {
      clearTimeout(inputTimeout);
      inputTimeout = setTimeout(() => {
        const body = JSON.stringify({ note: event.target.value });
        fetch('/cart/update', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: body,
        });
      }, 300);
    });
  }
}
 
if (!customElements.get('deployer-cart-note')) customElements.define('deployer-cart-note', DeployerCartNote);